import React, { createContext, useContext, useReducer, Fragment, useEffect } from 'react'
import { AuthContext } from '../../App/App';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import jwt from 'jwt-decode'
import Admin from './Admin';
import CustomerServices from './CustomerServices';
import User from './User';

export const NavbarContext = createContext()
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    color: 'white',
    backgroundColor: ' #6777ef'
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  list: {
    width: 250,
  },
  sidebarMenu: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

function Navbar() {
  const { stateAuth, dispatchAuth } = useContext(AuthContext);

  const token = jwt(localStorage.getItem('token-helpdesk-umy'));

  //sidebar
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    dispatchNavbar({
      type: 'DRAWER',
      left: open
    })
  };

  const initialReducer = {
    left: false,
    anchorEl: null,
    // page: token != null ? Number.isInteger(token.role_id) ? 'dashboard' : 'message' : null
    page: null
  }
  const reducer = (state, action) => {
    switch (action.type) {
      case "DRAWER":
        return {
          ...state,
          left: action.left,
        }
      case "ANCHOR":
        return {
          ...state,
          anchorEl: action.anchorEl,
        }
      case "PAGE":
        return {
          ...state,
          page: action.page,
        }
    }
  }
  const [stateNavbar, dispatchNavbar] = useReducer(reducer, initialReducer)

  useEffect(() => {
    if (stateNavbar.page != null) {
      switch (stateNavbar.page) {
        case "dashboard":
          dispatchAuth({
            type: 'PATH',
            page: 'Dashboard'
          })
          break;
        case "message":
          dispatchAuth({
            type: 'PATH',
            page: 'Message'
          })
          break;
        case "helpdesk":
          dispatchAuth({
            type: 'PATH',
            page: 'Helpdesk Chat'
          })
          break;
        case "whatsapp":
          dispatchAuth({
            type: 'PATH',
            page: 'WhatsApp Chat'
          })
          break;
        case "completedMessages":
          dispatchAuth({
            type: 'PATH',
            page: 'Completed Messages'
          })
          break;
        case "customerServices":
          dispatchAuth({
            type: 'PATH',
            page: 'Customer Services'
          })
          break;
        case "profile":
          dispatchAuth({
            type: 'PATH',
            page: 'Profile'
          })
          break;
        case "contact":
          dispatchAuth({
            type: 'PATH',
            page: 'Contact'
          })
          break;
        case "whatsappNumber":
          dispatchAuth({
            type: 'PATH',
            page: 'Whatsapp Number'
          })
          break;
        case "chatCategory":
          dispatchAuth({
            type: 'PATH',
            page: 'Chat Category'
          })
          break;
        case "master":
          dispatchAuth({
            type: 'PATH',
            page: 'Master Admin'
          })
          break;
        case "logout":
          dispatchAuth({
            type: "LOGOUT",
            message: null
          })
          break;
      }
    }

    return () => {
      dispatchNavbar({
        type: 'PAGE',
        page: null
      })
    }
  }, [stateNavbar.page])


  const classes = useStyles();
  const open = Boolean(stateNavbar.anchorEl);

  const handleMenu = (event) => {
    dispatchNavbar({
      type: 'ANCHOR',
      anchorEl: event.currentTarget
    })
  };

  const handleClose = () => {
    dispatchNavbar({
      type: 'ANCHOR',
      anchorEl: null
    })
  };

  const handleMenuIcon = (page) => {
    dispatchNavbar({
      type: 'PAGE',
      page: page
    })
    handleClose()
  };


  return (
    <Fragment>
      <AppBar className={classes.root} position="static">
        <Toolbar>
          <IconButton onClick={toggleDrawer('left', true)} edge="start" className={classes.menuButton} style={{ textDecoration: 'none', color: 'white' }} aria-label="menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Helpdesk
          </Typography>
          <div>
            <Typography style={{ cursor: 'pointer' }} onClick={handleMenu}>{Number.isInteger(token.role_id) ? token.status.replace(/['"]+/g, '') : token.user.replace(/['"]+/g, '')}</Typography>
          </div>
          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              style={{ textDecoration: 'none', color: 'white' }}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={stateNavbar.anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleMenuIcon.bind(this, 'profile')}>Profile</MenuItem>
              <MenuItem onClick={handleMenuIcon.bind(this, 'logout')}>Log Out</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer anchor={'left'} open={stateNavbar.left} onClose={toggleDrawer('left', false)}>
        <div>
          <img src="./assets/img/Umy-logo.png" alt="logo" width="100" className="shadow-light rounded-circle  m-4" />
          <Divider />
          <div
            className={clsx(classes.list)}
            role="presentation"
            onKeyDown={toggleDrawer('left', false)}
          >
            <NavbarContext.Provider value={{ stateNavbar, dispatchNavbar }}>
              {(token.role_id == 1) ? <Admin /> : (token.role_id == 2) ? <CustomerServices /> : <User />}
            </NavbarContext.Provider>
          </div>
        </div >
      </Drawer>
    </Fragment>
  )
}

export default Navbar
